import React, {PropTypes} from 'react';
import {Dropdown, DropdownToggle, DropdownItem, DropdownMenu} from 'reactstrap';
import {I18n} from 'react-redux-i18n';

class CustomDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  handleToggle = () => {
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
  //  const {petTypeList} = this.props;
  const petTypeList = this.props.petTypeList.sort();

    const petTypes = petTypeList.map((petType) => {
      return (
        <DropdownItem key={petType} onClick={() => {this.props.onSelected(petType);}}>{petType}</DropdownItem>
      );
    });

    return (
      <div className="dropdown float-right">
        <Dropdown isOpen={this.state.isOpen} toggle={this.handleToggle}>
          <DropdownToggle caret color="secondary">
            {I18n.t('CREATE_CUSTOM_LABEL')}
          </DropdownToggle>
          <DropdownMenu>
            {petTypes}
          </DropdownMenu>
        </Dropdown>
       
      </div>
    );
  }
}

CustomDropdown.propTypes = {
  onSelected: PropTypes.func.isRequired,
  petTypeList: PropTypes.array.isRequired
};

export default CustomDropdown;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/CustomDropdown.js
 **/